import { getOrSet } from "@redotech/util/map";
import { StorefrontTrackingConfig } from "./config";
import { getCoverageSplitEventsCallbacks } from "./event-handlers/regular-split-events";
import { StorefrontEventsProvider } from "./events-provider/storefront-events-provider";
import { StorefrontTrackingEventCallbackList } from "./storefront-tracking-event";

export const initialize = async ({
  config,
  analyticsProvider,
  location,
}: {
  config: StorefrontTrackingConfig;
  analyticsProvider: StorefrontEventsProvider;
  location: Location;
}) => {
  const callbacks = new Map() as StorefrontTrackingEventCallbackList;

  if (config.splitEnabled) {
    const basicSplitCallbacks = getCoverageSplitEventsCallbacks({
      storage: analyticsProvider.storage,
      baseRequestUrl: config.redoBaseRequestUrl,
      widgetId: config.merchantWidgetId,
      coverageProductIds: config.coverageProductIds,
    });
    for (const [key, value] of basicSplitCallbacks.entries()) {
      getOrSet(callbacks, key, () => []).push(...value);
    }
  }

  const subscribedEvents = Array.from(callbacks.keys());

  for (const eventType of subscribedEvents) {
    analyticsProvider.subscribe(eventType, async (event) => {
      const callbacksToRun = callbacks.get(event.type) || [];
      await Promise.all(callbacksToRun.map((callback) => callback(event)));
    });
  }
};
